import {
  FIRST_TIME_SETUP_GET_PASSWORD_REQUEST,
  FIRST_TIME_SETUP_GET_PASSWORD_SUCCESS,
  FIRST_TIME_SETUP_GET_PASSWORD_FAILURE,
  FIRST_TIME_SETUP_DEFINE_PASSWORD_REQUEST,
  FIRST_TIME_SETUP_DEFINE_PASSWORD_SUCCESS,
  FIRST_TIME_SETUP_DEFINE_PASSWORD_FAILURE,
} from '../FirstTimeSetupActionType';

const initialState = {
  loading: false,
  userName: '',
  currentPassword: '',
  definePassword: {
    loading: false,
    success: false,
    error: false,
  },
};

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case FIRST_TIME_SETUP_GET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FIRST_TIME_SETUP_GET_PASSWORD_SUCCESS: {
      const { userName, password } = action.payload;
      return {
        ...state,
        loading: false,
        userName,
        currentPassword: password,
      };
    }
    case FIRST_TIME_SETUP_GET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case FIRST_TIME_SETUP_DEFINE_PASSWORD_REQUEST:
      return {
        ...state,
        definePassword: {
          ...initialState.definePassword,
          loading: true,
        },
      };
    case FIRST_TIME_SETUP_DEFINE_PASSWORD_SUCCESS:
      return {
        ...state,
        definePassword: {
          ...initialState.definePassword,
          success: true,
        },
      };
    case FIRST_TIME_SETUP_DEFINE_PASSWORD_FAILURE:
      return {
        ...state,
        definePassword: {
          ...initialState.definePassword,
          error: true,
        },
      };
    default:
      return state;
  }
};
